import type { INotificationRepository, NotificationListOptions } from '../repositories/INotificationRepository.js';
import type { NotificationEntity } from '../entities/NotificationEntity.js';

interface Deps { notificationRepository: INotificationRepository; }

export function createListNotificationsUseCase({ notificationRepository }: Deps) {
  return function listNotifications(options: NotificationListOptions): Promise<NotificationEntity[]> {
    return notificationRepository.list(options);
  };
}
